// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchForm_inputWrapper__8hsBR","iconSearch":"SearchForm_iconSearch__Zfdxi","searchInput":"SearchForm_searchInput__h6REp"};